import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, interval } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ui-timer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
  template: `{{ currentTime$ | async }}`,
})
export class TimerComponent {
  currentTime$: Observable<string>;

  constructor() {
    this.currentTime$ = this.getCurrentTime();
  }

  getCurrentTime() {
    return interval(1000).pipe(
      takeUntilDestroyed(),
      map(() => {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}h`;
      }),
    );
  }
}
